// extracted by mini-css-extract-plugin
module.exports = {"sel":"filter_sel__1EDes"};